<template>
  <div class="vl-grid vl-grid--no-gutter dialpad-grid">
    <div v-for="key in dialpadKeys" :key="key" class="vl-col--1-3">
      <VlButton @click.prevent="$emit('press', key)" class="dialpad-btn">
        {{ key }}
      </VlButton>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Dialpad',
  data() {
    return {
        dialpadKeys: ['1','2','3','4','5','6','7','8','9','*','0','#']
    };
  }
}
</script>

<style scoped>
.dialpad-grid {
  padding:0.8rem 50px 0px;
}

.dialpad-grid > .vl-col--1-3 {
  margin-bottom: 10px;
}

.dialpad-btn {
  border-radius: 50%;
  width: 48px;
  height: 48px;
  padding: 0;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
</style>